import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  container: {
    padding: '20px',
    backgroundColor: 'var(--background-color)',
    minHeight: '100vh',
  },
  title: {
    color: 'var(--text-color)',
    marginBottom: '20px',
    fontWeight: 'bold',
  },
  
  // Search and Filters Section
  filtersContainer: {
    backgroundColor: 'var(--background-color-full)',
    borderRadius: '8px',
    padding: '20px',
    marginBottom: '20px',
    border: (props) => props.theme === 'light' ? '1px solid var(--border-color)' : 'none',
    boxShadow: 'var(--box-shadow)',
  },
  searchContainer: {
    display: 'flex',
    gap: '16px',
    flexWrap: 'wrap',
    alignItems: 'center',
  },
  searchField: {
    minWidth: '300px',
    flex: '1 1 400px',
    maxWidth: '600px',
    '& .MuiOutlinedInput-root': {
      backgroundColor: 'var(--background-color-secondary)',
      '& fieldset': {
        borderColor: 'var(--border-color)',
      },
      '&:hover fieldset': {
        borderColor: 'var(--text-color)',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#1976d2',
      },
    },
    '& .MuiInputLabel-root': {
      color: 'var(--text-secondary-color)',
    },
    '& .MuiOutlinedInput-input': {
      color: 'var(--text-color)',
    },
  },
  searchIcon: {
    color: 'var(--text-secondary-color)',
  },
  clearIcon: {
    color: 'var(--text-secondary-color)',
    '&:hover': {
      color: 'var(--text-color)',
    },
  },
  activeFilters: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    marginTop: '16px',
    flexWrap: 'wrap',
  },
  activeFiltersLabel: {
    color: 'var(--text-secondary-color)',
    fontWeight: '500',
  },
  filterChip: {
    backgroundColor: 'var(--background-color-secondary)',
    color: 'var(--text-color)',
    '& .MuiChip-deleteIcon': {
      color: 'var(--text-secondary-color)',
      '&:hover': {
        color: 'var(--text-color)',
      },
    },
  },

  // Table Section
  tableContainer: {
    backgroundColor: 'var(--background-color-full)',
    borderRadius: '8px',
    overflow: 'hidden',
    boxShadow: 'var(--box-shadow)',
    border: (props) => props.theme === 'light' ? '1px solid var(--border-color)' : 'none',
  },
  table: {
    minWidth: 650,
    '& .MuiTableCell-root': {
      borderBottom: '1px solid var(--border-color)',
    },
  },
  headerCell: {
    backgroundColor: 'var(--background-color-secondary)',
    color: 'var(--text-color)',
    fontWeight: 'bold',
    fontSize: '1rem',
    padding: '16px',
  },
  sortLabel: {
    color: 'var(--text-color) !important',
    '& .MuiTableSortLabel-icon': {
      color: 'var(--text-color) !important',
    },
    '&:hover': {
      color: 'var(--text-color) !important',
    },
    '&.Mui-active': {
      color: '#1976d2 !important',
      '& .MuiTableSortLabel-icon': {
        color: '#1976d2 !important',
      },
    },
  },
  tableRow: {
    backgroundColor: 'var(--background-color-full)',
    transition: 'background-color 0.2s ease',
    '&:hover': {
      backgroundColor: 'var(--background-color-secondary)',
    },
  },
  expandButton: {
    color: 'var(--text-color)',
    '&:hover': {
      backgroundColor: 'var(--background-color-secondary)',
    },
  },
  emailCell: {
    padding: '16px',
  },
  emailText: {
    color: 'var(--text-color)',
    fontSize: '0.95rem',
    fontWeight: '500',
  },
  countCell: {
    padding: '16px',
  },
  countText: {
    color: 'var(--text-color)',
    fontSize: '0.95rem',
    fontWeight: '600',
    textAlign: 'center',
  },
  collapseBox: {
    margin: '10px 0',
    padding: '0 20px 20px',
    backgroundColor: 'var(--background-color-secondary)',
    borderRadius: '4px',
  },
  subscriptionsTitle: {
    color: 'var(--text-color)',
    marginBottom: '10px',
    padding: '10px 0',
    fontSize: '1.1rem',
    fontWeight: 'bold',
  },
  subscriptionsTable: {
    '& .MuiTableCell-root': {
      borderBottom: '1px solid var(--border-color)',
      padding: '8px',
    },
  },
  subscriptionHeader: {
    backgroundColor: 'var(--background-color)',
    color: 'var(--text-secondary-color)',
    fontWeight: '600',
    fontSize: '0.85rem',
    textTransform: 'uppercase',
  },
  subscriptionCell: {
    color: 'var(--text-color)',
    fontSize: '0.85rem',
    maxWidth: '200px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  noDataCell: {
    textAlign: 'center',
    padding: '40px 16px',
  },
  noDataText: {
    color: 'var(--text-secondary-color)',
    fontSize: '1.1rem',
    fontStyle: 'italic',
  },

  // Pagination Section
  pagination: {
    backgroundColor: 'var(--background-color-secondary)',
    borderTop: '1px solid var(--border-color)',
    color: 'var(--text-color)',
    '& .MuiTablePagination-toolbar': {
      color: 'var(--text-color)',
    },
    '& .MuiTablePagination-selectLabel': {
      color: 'var(--text-color)',
    },
    '& .MuiTablePagination-displayedRows': {
      color: 'var(--text-color)',
    },
    '& .MuiTablePagination-select': {
      color: 'var(--text-color)',
    },
    '& .MuiTablePagination-actions': {
      color: 'var(--text-color)',
      '& .MuiIconButton-root': {
        color: 'var(--text-color)',
        '&:hover': {
          backgroundColor: 'var(--background-color)',
        },
        '&.Mui-disabled': {
          color: 'var(--text-secondary-color)',
        },
      },
    },
  },

  // Responsive design
  [theme.breakpoints.down('md')]: {
    table: {
      minWidth: 'auto',
    },
    subscriptionCell: {
      maxWidth: '120px',
      fontSize: '0.8rem',
    },
    emailText: {
      fontSize: '0.9rem',
    },
    searchContainer: {
      flexDirection: 'column',
      gap: '12px',
    },
    searchField: {
      minWidth: '100%',
    },
  },

  [theme.breakpoints.down('sm')]: {
    container: {
      padding: '10px',
    },
    filtersContainer: {
      padding: '15px',
    },
    subscriptionCell: {
      maxWidth: '100px',
      fontSize: '0.75rem',
    },
    collapseBox: {
      padding: '0 10px 10px',
    },
    searchField: {
      minWidth: '100%',
    },
    activeFilters: {
      marginTop: '12px',
    },
  },
})); 